import { ParsedVaultRewardsScheduleExpanded } from "@bridgesplit/abf-react";
import { convertDateJsToUnix, getUnixTs } from "@bridgesplit/utils";

import { EditRewardsForm } from "../common/types";

export function getManagerEditRewardFormValidation(
    form: EditRewardsForm,
    schedule: ParsedVaultRewardsScheduleExpanded | undefined
): string | undefined {
    if (!schedule) return "Loading";
    if (!form.rewardToken) return "No reward token selected";

    const newEndTime = convertDateJsToUnix(form.rewardEndTime);
    if (newEndTime && newEndTime <= getUnixTs()) {
        return "End time must be in the future";
    }

    const isEndTimeChanged = newEndTime !== undefined && newEndTime !== schedule.rewardEndTime;
    if (form.rewardAmount === undefined && !isEndTimeChanged) {
        return "No changes to apply";
    }

    return undefined;
}
